/**
 * function unwrapData (is being used with api-client-lite and CRAPI)
 * it needed because api client wraps response in 'data' object + CRAPI by default returns 'data' wrapped
 * the problem occurs when there's and error response which isn't wrapped in 'data' object by CRAPI
 * @param response
 * @returns {Object}
 */
const unwrapData = response => (response.data ? response.data : response);

export default unwrapData;
